// ✅ Visitor Routes Wrapped with VisitorLayout (Restricted AI Version)
// Updated: 2025-11-19

import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// Layout
import VisitorLayout from "../../../layouts/VisitorLayout";

// Pages
import CreateVisitPage from "../pages/CreateVisitPage";
import VisitApprovalsPage from "../pages/VisitApprovalsPage";
import VisitApprovalDetailPage from "../pages/VisitApprovalDetailPage";
import CheckInPage from "../pages/CheckInPage";
import CheckOutPage from "../pages/CheckOutPage";
import VisitorDashboardPage from "../pages/VisitorDashboardPage";
import VisitorReportsPage from "../pages/VisitorReportsPage";

// ⭐ Visitor AI Assistant Imports
import { VisitorAIProvider } from "../../../visitor_ai/context/VisitorAIContext";
import VisitorAIChat from "../../../visitor_ai/components/VisitorAIChat";

function VisitorRoutes() {
  const location = useLocation();

  // ⭐ AI Allowed Routes — only 3 pages:
  const allowedAIPaths = [
    "/visitor/dashboard",
    "/visitor/create",
    "/visitor/approvals",
  ];

  // Check if current route starts with any allowed path
  const showAI =
    allowedAIPaths.some((path) => location.pathname.startsWith(path));

  return (
    <VisitorAIProvider>
      <VisitorLayout>
        <Routes>
          {/* ⭐ Pages where AI is allowed */}
          <Route path="dashboard" element={<VisitorDashboardPage />} />
          <Route path="create" element={<CreateVisitPage />} />
          <Route path="approvals" element={<VisitApprovalsPage />} />
          <Route path="approvals/:id" element={<VisitApprovalDetailPage />} />

          {/* ❌ Pages where AI should NOT appear */}
          <Route path="checkin" element={<CheckInPage />} />
          <Route path="checkout" element={<CheckOutPage />} />
          <Route path="reports" element={<VisitorReportsPage />} />
        </Routes>
      </VisitorLayout>

      {/* ⭐ Conditionally render AI bubble ONLY on allowed pages */}
      {showAI && <VisitorAIChat pageContext={{ module: "visitor" }} />}
    </VisitorAIProvider>
  );
}

export default VisitorRoutes;
